import IIntervention from 'models/Intervention';

import { ReduxStore } from 'store/types';

function getAllList(state: ReduxStore): IIntervention[] {
  return state.intervention.getAll.list;
}

export default getAllList;
